<template>
  <section :class="[ 'ugc-top-bar row', { hide } ]">
    <div class="small-1 columns ugc-top-bar-close">
      <button
        v-show="!isGCC"
        @click="exit"
        :disabled="!hideFinishButton && isFinishButtonDisabled"
        class="ugc-modal-button ugc-top-bar-close-icon"
        type="button"
      >
        <span class="icon-close"></span>
      </button>
    </div>
    <ugc-steps-view v-if="!hide" :customizerHeaderUGCLargeButton="customizerHeaderUGCLargeButton"></ugc-steps-view>
    <button
      type="button"
      @click="checkPlacement"
      :disabled="toggleNextButton"
      :class="[
        'columns ugc-top-bar-next ugc-modal-button',
        customizerHeaderUGCLargeButton ? 'small-3' : 'small-2',
        { hide: hideUGCNextButton }
      ]"
    >
      {{ translations.ugcTopBarNext }} &gt;
    </button>
    <button
      type="button"
      @click="finish"
      :class="[
        'small-2 columns ugc-top-bar-finish primary button',
        { hide: hideFinishButton },
        { disabled: isFinishButtonDisabled }
      ]"
    >
      {{ translations.ugcTopBarFinish }}
    </button>
  </section>
</template>

<script>
import UgcStepsView from "./StepsView";
import ugc from '@/mixins/UGC';

export default {
  name: "UgcTopbar",
  components: {
    UgcStepsView
  },
  mixins: [ ugc ],
  props: {
    hide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hideUGCNextButton: false,
      hideFinishButton: true,
      isNextButtonDisabled: false,
      isFinishButtonDisabled: true,
      gccHandlersCount: 0,
      customizedComponents: []
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    uploadedAnother() {
      return this.$store.getters['ugc/tempData/uploadedAnotherImage'];
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    ugcFeature() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugcFeature;
    },
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCComponent;
    },
    returnPlacementViewOrder() {
      return this.$store.getters["ugc/tempData/getPlacementViewOrder"];
    },
    getMultipart() {
      return this.$store.getters["ugc/tempData/checkMultipart"];
    },
    toggleNextButton() {
      return (
        this.$store.state.ugc.stateManager.activeControl !== "" ||
        this.isNextButtonDisabled
      );
    },
    getUGCCustomizedComponents() {
      return Object.keys(this.$store.state.ugc.tempData.features[this.activeUGCIndex].recipe.components)
        .length;
    },
    getUGCEnabledComponents() {
      return this.$store.getters["ugc/getUGCEnabledComponents"]();
    },
    getFeatureName() {
      if (this.ugcFeature && this.uploadedAnother) return null;
      if (this.ugcFeature && !this.uploadedAnother) return this.ugcFeature;
      return this.$store.state.utils.queryParams.feature;
    },
    getSize() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugc_size;
    },
    isGCC() {
      return this.$store.getters["utils/isGCC"];
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    storeMultipleUGCsizes() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].storeMultipleUGCsizes;
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    checkerboarderActive() {
      return this.$store.state.utils.queryParams.feature === 'checkerboarder';
    },
    customizerHeaderUGCLargeButton() {
      // TODO: refactor and rename this in VFDP-115984, leverage caid configuration.json
      return this.$store.state.utils.caid === 'apac-zh-cn-tmall';
    },
    activeUgcFeatureId() {
      return this.$store.getters["ugc/tempData/getActiveUGCIndexId"];
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.configuration.enableNewUgcModal ? "newUgcModal" : "ugcModal");
    },
    /**
     * @function checkPlacement
     * Checks whether UGC image fills placement guide completely
     * and either continues the flow or displays a warning modal
     * @returns {Boolean}
     */
    checkPlacement() {
      if (this.useEcomDataLayerFormat && !this.checkerboarderActive) {
        const eventAction = this.activeUgcFeatureId;
        this.$ugcDataLayer.logAnalyticsEvent({
          action: eventAction,
          type: this.$ugcDataLayer.types.clickUgctool,
          eventLabel: 'Next'
        });
      }

      const ugcImage = this.fabricCanvas.getObjects("image")[0];
      let placementOverlay = ugcImage.canvas.overlayImage;
      if(this.fabricCanvas.overlayImage.getObjects().find(item => item.id === "outer_layer")) {
        placementOverlay = this.fabricCanvas.getObjects().find(item => item.id === "placement");
      }
      if (placementOverlay) {
        const placementCorrect = placementOverlay.isContainedWithinObject(ugcImage);
        const { tempData } = this.$store.state.ugc;
        const backgroundApplied = tempData.features[tempData.activeUGCIndex].background_color;
        if (!backgroundApplied && !placementCorrect) {
          this.$modal.show(!!this.$store.state.utils.configuration.modals?.ugcPlacementError ? "ugcPlacementWarningModal" : "NewPlacementWarningModal");
        } else {
          this.nextStep();
        }
      }
    },
    /**
     * @function nextStep
     * On click goes to the next step in the ugc flow, if multipart is one opens the confirm design modal
     * If multipart is 2 or more sends the flow to the next placement view
     */
    nextStep() {
      if(this.fabricCanvas.overlayImage.getObjects().find(item => item.id === "outer_layer")) {
        const placementOverlay = this.fabricCanvas.getObjects().find(item => item.id === "placement");
        if(placementOverlay) this.fabricCanvas.remove(placementOverlay);
      }
      this.$store.commit("ugc/stateManager/SET_LOADING", true);
      this.lockFabricFeatures(true);
      this.lockFabricMovement(true);
      this.$store.commit("ugc/stateManager/NEXT_CURRENT_UGC_VIEW");
      let multipart = this.getMultipart;
      this.$eventBus.$emit("hide-customs-spinner", false);

      // TODO imageLibrary dataLayer GLOBAL15-31502
      if (!this.useEcomDataLayerFormat && this.returnPlacementViewOrder === 0) {
        if (this.getFeatureName) {
          this.$ugcDataLayer.logAnalyticsEvent({
            action: this.getFeatureName,
            type: this.$ugcDataLayer.types.applyEdits,
            style: this.$store.state.utils.pdmModel
          });
        }
        else {
          this.$ugcDataLayer.logAnalyticsEvent({
            action: 'ugc',
            type: this.$ugcDataLayer.types.next,
            eventLabel: this.$store.getters['ugc/getEditsApplied']
          });
        }
      }

      this.savePlacement().then(() => {
        if (
          multipart === 1 ||
          multipart === this.returnPlacementViewOrder + 1
        ) {
          if (!this.customizedComponents.includes(this.componentName)) {
            this.customizedComponents.push(this.componentName);
          }
          this.finishFlow();
        } else {
          if (this.activeUGCIndex === 1) {
            this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", true);
          }
          this.setupNextPlacement();
        }
      });
    },
    /**
     * @function savePlacement
     * Sends the placement image data to the endpoint
     * Saves the response in the store
     */
    savePlacement() {
      const { tempData } = this.$store.state.ugc;
      const { background_color } = tempData.features[tempData.activeUGCIndex];
      if (!background_color) {
        this.fabricCanvas.setBackgroundColor("transparent");
      }
      const canvasJSON = this.fabricCanvas.toJSON([
        "borderColor",
        "cornerStrokeColor",
        "backgroundColor",
        "cornerColor",
        "fillStyle",
        "borderScaleFactor",
        "strokeStyle",
        "transparentCorners",
        "hasControls",
        "lockMovementX",
        "lockMovementY",
        "lockRotation",
        "lockScalingFlip",
        "lockScalingX",
        "lockScalingY",
        "lockUniScaling"
      ]);
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("ugc/placements/UPLOAD_PLACEMENT", {
            componentName: this.componentName,
            productName: this.pdm.sku,
            tonalstitch: this.returnPlacementViewOrder === 0 ? "1" : null,
            size: this.getSize,
            placements: [
              {
                placementName: this.translations[`ugcPlacement1Name1-${this.componentName}`],
                imageJson: canvasJSON
              }
            ]
          })
          .then(response => {
            this.$store.commit("ugc/placements/SAVE_PLACEMENT_IMAGE", {
              imageData: response.data[0],
              canvasJSON: canvasJSON
            });
            this.fabricCanvas.setBackgroundColor(background_color || (this.$store.state.utils.configuration.enableNewUgcModal ? "#f3f3f3" : "#ffffff"));
            resolve();
          })
          .catch(reject);
      });
    },
    /**
     * @function lockFabricFeatures
     * Lock fabric image properties in order to prevent changes in the image
     * during transition views.
     */
    lockFabricFeatures(state) {
      this.$store.dispatch("ugc/LOCK_FABRIC_FEATURES", {
        fabricCanvas: this.fabricCanvas,
        lockFeatures: state
      });
    },
    /**
     * @function lockFabricMovement
     * Lock fabric movement between components transitions
     * Every time next is called the fabric canvas is locked.
     */
    lockFabricMovement(lock) {
      if (lock) {
        this.$eventBus.$emit("disable-events-fabric-canvas");
      }
      const canvas = this.fabricCanvas.getObjects()[0];
      canvas.lockMovementX = lock;
      canvas.lockMovementY = lock;
    },
    /**
     * @function setupNextPlacement
     * Sets the canvas up for the next placement image
     */
    setupNextPlacement() {
      if (this.activeUGCIndex === 1) this.$store.commit("imageGallery/NEXT_VIEW");
      this.$store.commit("ugc/tempData/UPDATE_PLACEMENT_VIEW_ORDER", true);
      this.$store.commit("ugc/stateManager/SET_LOADING", true);
      this.$eventBus.$emit("hide-customs-spinner", false);
      this.$eventBus.$emit("reload-placement-guide", true);
      //will add the emit to change the texts
      this.$store
        .dispatch("ugc/LOCK_FABRIC_FEATURES", {
          fabricCanvas: this.fabricCanvas,
          lockFeatures: !this.isGCC
        })
        .then(() => {
          this.lockFabricMovement(false);
          this.$nextTick(()=>{
            document.querySelector("#close-button-newUgcModal").focus();
          });
        });
      if (this.isGCC) {
        this.$store.commit("ugc/stateManager/SET_LOADING", false);
        this.$eventBus.$emit("image-set");
      }
      if (!this.$store.getters['utils/useEcomDataLayerFormat']) {
        dataLayer.push({
          ugcStep: `setPlacement2`,
          timeStamp: new Date().toISOString(),
          event: "ugcStep",
          eventCategory:'customs',
          eventAction:'UGC',
          eventLabel: `setPlacement2`,
        });
      }
    },
    repositionComponentFeatureCheck(componentName) {
      if (!this.storeMultipleUGCsizes) return;
      const isComponentLibrary = this.$recipe.checkForImageLibraryComponent(componentName);

      if (isComponentLibrary) {
        this.$store.commit("ugc/tempData/SET_UGC_FEATURE", "library");
      } else {
        this.$store.commit("ugc/tempData/SET_REPLACE_COMPONENT_FEATURE", componentName);
      }
    },
    /**
     * @function finishFlow
     * Sends the placements to the endpoint and receive an ugc swatch
     * Save the ugc swatch in store
     * Open confirm design
     */
    finishFlow() {
      // TODO GLOBAL15-57773 final fix for reposition flow with mixed features before SAVE_UGC_SWATCH to prevent need of overwriting
      this.repositionComponentFeatureCheck(this.componentName);
      // TODO if multipart 2, imageLibrary AND ugc, and responses[0] is undefined we need to get from tempData or selectedImages
      // this.$store.state.ugc.placements.responses[this.componentName]
      this.$store.dispatch("ugc/GET_UGC_SWATCH", {
        productName: this.pdm.sku,
        size: this.getSize,
        componentName: this.componentName,
        placements: this.$store.state.ugc.placements.responses[this.componentName]
      })
        .then(({ data }) => {
          this.$store.commit("ugc/tempData/SET_APPLY_UGC_COMPONENTS",this.componentName);
          this.$store.dispatch("ugc/SAVE_UGC_SWATCH", data);
          this.$store.commit("ugc/tempData/SAVE_STATE_MANAGERS", this.$store.state.ugc.stateManager);
          this.$store.commit("ugc/NEXT_UGC_VIEW");
          if (this.isGCC) {
            if (this.customizedComponents.indexOf(this.componentName) < this.$store.getters["ugc/getUGCEnabledComponents"].length - 1) {
              this.skipAlmostDoneModal();
            }
            this.lockFabricFeatures(false);
            this.lockFabricMovement(false);
          } else {
            this.hideNextButton(true);
          }

          this.$eventBus.$emit("hide-customs-spinner", true);
          if (this.$store.state.ugc.tempData.activeUGCIndex === 1) this.$eventBus.$emit("update-component-image-library");
        });
    },
    clearStoredData() {
      this.$store.commit("ugc/tempData/RESET_PLACEMENT_VIEW_ORDER");
    },
    clearGCCStateManager() {
      this.gccHandlersCount++;
      if (this.gccHandlersCount < 2) return;
      this.$store.commit("ugc/stateManager/RESET");
      this.$store.dispatch("ugc/stateManager/STORE_STEP");
      this.$store.commit("ugc/stateManager/SET_LOADING", false);
      this.gccHandlersCount = 0;
    },
    skipAlmostDoneModal() {
      this.clearStoredData();
      this.resetFiltersForGCC();

      this.$store.dispatch("ugc/SAVE_ASSETS_3D").then(() => {
        this.$store.commit("ugc/tempData/ADD_UGC_COMPONENT", {
          componentName: this.componentName,
          defaultUGCSwatchId: this.$store.state.recipe.initRecipe.components[this.componentName].swatch_id,
          uploadedAnother: this.uploadedAnother,
        });
        this.$store.commit("ugc/stateManager/SET_LOADING", true);
        this.$eventBus.$once("gcc-autoupdate-finish", this.clearGCCStateManager);
        this.$eventBus.$once("placement-loaded", this.clearGCCStateManager);
        this.$eventBus.$emit("reload-placement-guide", true);
        this.$eventBus.$emit("image-set");
      });
    },
    hideNextButton(visible) {
      this.hideUGCNextButton = visible;
    },
    showFinishButton(visible) {
      this.hideUGCNextButton = visible;
      this.hideFinishButton = !visible;
    },
    disableNextButton(disabled) {
      this.isNextButtonDisabled = disabled;
      this.$emit('disable-next-back-buttons', disabled);
    },
    disableFinishButton() {
      this.isFinishButtonDisabled = false;
    },
    finish() {
      if (this.isFinishButtonDisabled) return;
      if (this.getFeatureName) {
        this.$ugcDataLayer.logAnalyticsEvent({
          action: this.getFeatureName,
          type: this.$ugcDataLayer.types[this.useEcomDataLayerFormat ? 'finish' : 'confirmDesign'],
          style: this.$store.state.utils.pdmModel
        });
      } else {
        const eventAction = this.$store.state.transferDesign.isCustomizerTransferredModel ? 'transferDesign' : this.activeUgcFeatureId;
        this.$ugcDataLayer.logAnalyticsEvent({
          action: eventAction,
          type: this.$ugcDataLayer.types.complete
        });
      }

      this.isFinishButtonDisabled = true;
      this.$eventBus.$emit("show-spinner-finish");
      this.$store.commit("ugc/stateManager/SET_LOADING", true);

      const personalizationComponent = this.$store.getters["personalization/getPersonalizationComponentName"];
      const personalization = personalizationComponent &&
        this.recipe_v2.components[personalizationComponent] &&
        this.recipe_v2.components[personalizationComponent].personalization;

      if (personalization) {
        personalization.forEach((data, index) => this.$store.commit("personalization/SAVE_DATA", { text: data.text, index, data }));
      }

      if (this.$store.state.ugc.tempData.activeUGCIndex === 1) this.$eventBus.$emit('finish-image-library-edit');
      this.$eventBus.$emit('init-ugc-appliance', { personalizationData: personalization });
    },
    /**
     * TODO save ugc/placements buffers for 1st component
     */
    openImageLibraryModal({isReplaceTool = false, selectAnother = false, goBack = false}) {
      if (!isReplaceTool && !selectAnother && !goBack) {
        this.exit();
        return;
      }
      if (isReplaceTool) this.$store.commit("ugc/tempData/IS_REPLACE_TOOL", isReplaceTool);
      if (selectAnother) this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", selectAnother);
      this.$store.commit("imageGallery/SET_IS_BACK_APPLIED", goBack);
      if (goBack) {
        this.closeModal();
        this.$modal.show('addYourImageGallery');
        this.$store.commit("ugc/tempData/SET_CONTINUE_EDIT_FLOW", false);
        return;
      }
      const currentUgcView = this.$store.state.ugc.stateManager.currentUgcView;
      this.$store.commit("imageGallery/SET_CURRENT_UGC_VIEW", currentUgcView);
      if (this.configuration.ugc.enableUgcExitAlert) {
        if (confirm(this.translations.ugcExitAlertMessage)) {
          this.closeModal();
        }
      } else {
        this.closeModal();
      }
    },
    exit() {
      if (this.useEcomDataLayerFormat && !this.checkerboarderActive) {
        this.$ugcDataLayer.logAnalyticsEvent({
          action: !!this.activeUgcFeatureId ? this.activeUgcFeatureId : 'ugc',
          type: this.$ugcDataLayer.types.clickUgctool,
          eventLabel: 'Close'
        });
      }
      this.$store.commit("ugc/stateManager/APPLY_TILE_OR_POPART", false);
      this.$store.commit("ugc/tempData/SET_TEMP_BUCKET_SIZE", null);
      if (this.$store.state.ugc.tempData.activeUGCIndex === 1) this.$eventBus.$emit('image-library-reset-states');
      if (this.configuration.ugc.enableUgcExitAlert) {
        if (confirm(this.translations.ugcExitAlertMessage)) {
          this.closeModal();
        }
      } else {
        this.closeModal();
      }

      // Validate if UGC feature still available
      this.applyUGCFeatureGeometry();

      if (this.storeMultipleUGCsizes) {
        const { ugcSize } = this.$store.state.buyPanel;
        this.$store.commit("buyPanel/REPLACE_SIZE_SELECTED", ugcSize);
        this.$store.commit('ugc/tempData/SET_STORE_MULTIPLE_UGC_SIZES', false);
        this.$eventBus.$emit('show-buy-panel');
      }
    },
    resetFiltersForGCC() {
      const canvas = this.fabricCanvas;
      const img = canvas.getObjects()[0];
      if (img.filters.length > 0 && img.filters[0].type === "BlendColor") {
        img.filters = [];
        img.applyFilters();
        canvas.renderAll();
      }
    }
  },
  created() {
    this.$eventBus.$on("placement-warning-continue", this.nextStep);
    this.$eventBus.$on("hide-next-button", this.hideNextButton);
    this.$eventBus.$on("show-finish-button", this.showFinishButton);
    this.$eventBus.$on("disable-finish-button", this.disableFinishButton);
    this.$eventBus.$on("disable-next-back-buttons", this.disableNextButton);
    this.$eventBus.$on("image-library-close-ugc", this.openImageLibraryModal);
  },
  mounted() {
    this.$store.commit("ugc/stateManager/SET_ACTIVE_CONTROL", "");
  },
  beforeDestroy() {
    const { tempData } = this.$store.state.ugc;
    this.customizedComponents = [];
    this.$eventBus.$emit("reset-input-file");
    this.$eventBus.$off("placement-warning-continue", this.nextStep);
    this.$eventBus.$off("hide-next-button", this.hideNextButton);
    this.$eventBus.$off("show-finish-button", this.showFinishButton);
    this.$eventBus.$off("disable-finish-button", this.disableFinishButton);
    this.$eventBus.$off("disable-next-back-buttons", this.disableNextButton);
    this.$eventBus.$off("image-library-close-ugc", this.openImageLibraryModal);
    this.$store.commit("ugc/stateManager/CLEAR");
    // Dont clear tempData for imageLibrary replace tool or 2nd component flow
    if(
      tempData.activeUGCIndex !== 1 ||
      (tempData.activeUGCIndex === 1 &&
      !tempData.features[this.activeUGCIndex].selectAnother &&
      !tempData.features[tempData.activeUGCIndex].isReplaceTool &&
      !this.$store.state.imageGallery.isBackToLibraryApplied)
    ) {
      this.$store.commit("ugc/tempData/CLEAR");
      this.$store.commit("ugc/placements/CLEAR_ALL");
    }

    this.$store.commit("ugc/stateManager/RESTART_STATE_MANAGER");
    if(tempData.activeUGCIndex === 1 && (tempData.features[tempData.activeUGCIndex].selectAnother || this.$store.state.imageGallery.isBackToLibraryApplied)) {
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_COMPONENT", tempData.features[tempData.activeUGCIndex].activeUGCComponent);
    } else {
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_COMPONENT", tempData.features[tempData.activeUGCIndex].ugcFlowComponents[0]);
    }
  }
};
</script>
